export const HINT_REGEX = /(\d+)|^(\d+)\s+|\s+(\d+)$/;

export const isStreetNumberMissing = (value: string) => {
  const match = value.match(HINT_REGEX);

  return !(match?.[1] || match?.[2] || match?.[3]);
};
